"use client";
import { memo } from "react";
import dynamic from "next/dynamic";
import Spinner from "@/components/ui/spinner";
import CheckoutHeader from "@/components/screen/global-components/checkout/CheckoutHeader/CheckoutHeader";

const Checkout = dynamic(
  () => {
    return import("./components/Checkout");
  },
  {
    ssr: false,
    loading: () => {
      return (
        <div className="flex flex-auto items-center justify-center w-full">
          <Spinner />
        </div>
      );
    },
  }
);

export const StartOrderPage = () => {
  return (
    <>
      <CheckoutHeader isProgressBar />
      <main className="w-full full-height bg-white flex flex-col">
        <Checkout className="flex-auto" />
      </main>
    </>
  );
};

export default memo(StartOrderPage);
